/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_PlanInputs */

const en_settings_overview_plan = /** @type {(inputs: Settings_Overview_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Settings_Overview_PlanInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_overview_plan = /** @type {((inputs?: Settings_Overview_PlanInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_PlanInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_overview_plan(inputs)
});
export { settings_overview_plan as "settings.overview.plan" }